module.exports = "/assets/site/images/partner_logo_place_holder.png?a4a1833875cd83d4980f9131212f0798";